import React from 'react';
import styled from 'styled-components';
import { rhythm } from 'Themes/typography';
import { Input, FormControl, Grid } from '@material-ui/core';
import { takeInitials } from 'Utils';
import FieldError from '../components/FieldError';
import New from 'Images/new.svg';

const Container = styled.div`
  padding: ${rhythm(0.3)} 0;
  position: relative;
  height: 100%;
`;
const CopyTxt = styled.div`
  font-size: 12px;
`;
const Heading = styled.h1`
  font-size: 1rem;
`;
const InnerContainer = styled.div`
  padding-bottom: ${rhythm(2.5)};
`;
const OldNotes = styled.div`
  padding-bottom: ${rhythm(2.5)};
  display: flex;
  justify-content: space-between;
`;
const ContactContainer = styled.div`
  margin: ${rhythm(1)};
`;
const PadTop = styled.div`
  padding-top: ${rhythm(1)};
`;

const NotesGeneral = styled.div`
  font-family: Helvetica, Arial, sans-serif;
  padding-left: 5px;
  word-break: break-all;
`;
const Notes = styled.ol`
  type: '1';
`;
const NotesDemand = styled.div`
  font-weight: normal;
  div {
    display: flex;
    align-items: center;
    img {
      height: 40px;
      margin-bottom: 0 !important;
    }
  }
`;

const Title = styled.div`
  font-weight: 600;
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  font-size: 0.75rem;
`;

const Values = styled.div`
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  font-size: 0.875rem;
  color: ${({ theme }) => theme.palette.blue.main};
  display: inline-flex;
  align-items: center;
`;
const NotesDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

const Image = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  margin-left: 0.5rem;
`;

const ImagePlaceholder = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  margin-right: 0.5rem;
  background: ${({ theme }) => theme.palette.blue.main};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
`;

const ReqInput = styled(Input)`
  &&&:before {
    border-bottom: 1px solid rgba(255, 0, 0, 0.42);
  }
  &&&:after {
    border-bottom: 2px solid rgba(255, 0, 0, 0.42);
  }
  &&&:hover:before {
    border-bottom: 2px solid rgba(255, 0, 0) !important;
  }
`;
const ReqText = styled.span`
  color: rgba(255, 0, 0, 0.42);
`;
const InfoWrapper = styled.div`
  padding: ${rhythm(0.5)} 0;
  color: #62727b;
`;

const separateNotes = (note, isUpdated) => {
  let finalNotes = '';
  if (note) {
    const split = note.split('_$_');
    split.forEach((el, index) => {
      if (index + 1 === split.length && isUpdated) {
        finalNotes +=
          '<div><b style="color:hsla(0,0%,0%,0.8);">' +
          '•' +
          '</b><img src="' +
          New +
          '"/>' +
          el +
          '<br/></div>';
      } else {
        finalNotes +=
          '<b style="color:hsla(0,0%,0%,0.8);">' + '•' + '</b> ' + el + '<br/>';
      }
    });
  }
  return { __html: finalNotes };
};

const NoteAndUrl = ({
  onUrlAndNoteChange,
  note,
  noteError,
  urlError,
  url,
  isSlipDiscarded,
  shortlisted,
  notes,
  details,
  notesGeneral,
  isUpdated,
  addGeneralNote,
  generalNotes,
}) => (
  <Container>
    {shortlisted ? (
      <NotesDetailsContainer>
        <div>
          <Heading>
            <div>General notes</div>
          </Heading>
          <Input
            onChange={addGeneralNote('generalNotes')}
            value={generalNotes}
            fullWidth
            placeholder="Add general note"
            disabled={isSlipDiscarded}
          />
        </div>

        <div style={{ bottom: '0' }}>
          <Heading>Contact details</Heading>
          <ContactContainer>
            <Grid container spacing={8} alignItems="center">
              <Grid item xs={4}>
                <Title>Name:</Title>
              </Grid>
              <Grid item xs={8}>
                <Values>{details.manufacturer}</Values>
              </Grid>
            </Grid>

            <Grid container spacing={8} alignItems="center">
              <Grid item xs={4}>
                <Title>Phone:</Title>
              </Grid>
              <Grid item xs={8}>
                <Values>{details.mobile}</Values>
              </Grid>
            </Grid>
          </ContactContainer>
        </div>
      </NotesDetailsContainer>
    ) : (
      <React.Fragment>
        <Heading>
          <div>
            URL<ReqText>*</ReqText>
            <CopyTxt>(Copy and paste full address from browser)</CopyTxt>
          </div>
          {urlError && <FieldError>{urlError}</FieldError>}
        </Heading>
        <InnerContainer>
          <FormControl fullWidth>
            <ReqInput
              onChange={onUrlAndNoteChange('url')}
              value={url}
              fullWidth
              placeholder="http://yourcompany.com/luminaire"
              disabled={isSlipDiscarded}
            />
          </FormControl>
        </InnerContainer>
        {/* <InfoWrapper>
          <div>Copy and paste full address from browser.</div>
          <div>Example format: http://luminairebroker.arup.com</div>
        </InfoWrapper> */}
      </React.Fragment>
    )}
  </Container>
);

export default NoteAndUrl;
